import { ColumnDefinition } from "@codat/orchard-ui";
import React from "react";

import styles from "./ManagedBankFeeds.module.scss";
import { StatusPill } from "./StatusPill";

const TruncatedCell: React.FC<{ value: string }> = ({ value }) => (
  <div className={styles.leftAlign}>{truncateString(value)}</div>
);

const DateTimeCell: React.FC<{ value: string }> = ({ value }) => {
  const localeDate = new Date(value).toLocaleString();
  return (
    <div className={styles.leftAlign}>
      {localeDate === "Invalid Date" ? "-" : localeDate}
    </div>
  );
};

const truncateString = (value: string) => {
  const truncatedLength = 9;
  if (value.length > truncatedLength) {
    return value.substring(0, truncatedLength) + "...";
  }
  return value;
};

export const columnDefs: ColumnDefinition<
  | "Company Name"
  | "Source Account ID"
  | "Execution Start Utc"
  | "Execution End Utc"
  | "Period Start Utc"
  | "Period End Utc"
  | "Status"
>[] = [
  {
    key: "Company Name",
    label: "Company Name",
    component: TruncatedCell,
    headerAlign: "center",
    align: "center",
  },
  {
    key: "Source Account ID",
    label: "Source Account ID",
    component: TruncatedCell,
    headerAlign: "center",
    align: "center",
  },
  {
    key: "Execution Start Utc",
    label: "Execution Start",
    component: DateTimeCell,
    headerAlign: "center",
    align: "center",
  },
  {
    key: "Execution End Utc",
    label: "Execution End",
    component: DateTimeCell,
    headerAlign: "center",
    align: "center",
  },
  {
    key: "Period Start Utc",
    label: "Period Start",
    component: DateTimeCell,
    headerAlign: "center",
    align: "center",
  },
  {
    key: "Period End Utc",
    label: "Period End",
    component: DateTimeCell,
    headerAlign: "center",
    align: "center",
  },
  {
    key: "Status",
    label: "Status",
    component: StatusPill,
    headerAlign: "center",
    align: "center",
  },
];

export interface syncOverview {
  syncId: string;
  clientId: string;
  companyName: string;
  companyId: string;
  dataConnectionId: string;
  sourceAccountId: string;
  executionStartUtc: string;
  executionEndUtc: string;
  periodStartUtc: string;
  periodEndUtc: string;
  status: string;
  errorMessage: string;
  errorCode: string;
}

export const tableRows = (
  onRowClick: (syncId: string) => void,
  data: syncOverview[]
): {
  onClick: () => void;
  data: { value: string; key: string }[];
}[] => {
  if (data.length <= 0) {
    return [];
  }
  return data.map((item) => {
    return {
      data: [
        {
          key: "Company Name",
          value: item.companyName,
        },
        {
          key: "Source Account ID",
          value: item.sourceAccountId,
        },
        {
          key: "Execution Start Utc",
          value: item.executionStartUtc,
        },
        {
          key: "Execution End Utc",
          value: item.executionEndUtc,
        },
        {
          key: "Period Start Utc",
          value: item.periodStartUtc,
        },
        {
          key: "Period End Utc",
          value: item.periodEndUtc,
        },
        {
          key: "Status",
          value: item.status,
        },
      ],
      onClick: () => {
        onRowClick(item.syncId);
      },
    };
  });
};
